import React, { useState, useEffect } from "react";
import {
  getAllPost,
  sendToGroup,
  deletePost,
} from "../../services/postService";
import { fetchPostById } from "../../services/userServices";
import { Link } from "react-router-dom";
import { getCategories } from "../../services/productServices";
import parse, { domToReact } from "html-react-parser";
import DashboardStatusGrid from "./DashboardStatusGrid";
import Spinner from "../shared/Spinner";

// sanitizeHtmlForTelegram removed - not used
/* function sanitizeHtmlForTelegram(html, bulletEmoji = "🔹") {
  const root = parseHtml(html);

  function walk(node, depth = 0, listType = null, index = 1) {
    if (node.nodeType === 3) {
      // text node
      return node.rawText;
    }
    const tag = node.tagName?.toUpperCase();
    switch (tag) {
      case "P": {
        const txt = walkChildren(node).trim();
        return txt ? txt + "\n\n" : "";
      }
      case "BR":
        return "\n";
      case "H1": {
        const txt = walkChildren(node).trim();
        return txt ? `<b style="font-size: 2em;">${txt}</b>\n\n` : "";
      }
      case "H2": {
        const txt = walkChildren(node).trim();
        return txt ? `<b style="font-size: 1.75em;">${txt}</b>\n\n` : "";
      }
      case "H3": {
        const txt = walkChildren(node).trim();
        return txt ? `<b style="font-size: 1.5em;">${txt}</b>\n\n` : "";
      }
      case "H4": {
        const txt = walkChildren(node).trim();
        return txt ? `<b style="font-size: 1.25em;">${txt}</b>\n\n` : "";
      }
      case "H5": {
        const txt = walkChildren(node).trim();
        return txt ? `<b style="font-size: 1.1em;">${txt}</b>\n\n` : "";
      }
      case "H6": {
        const txt = walkChildren(node).trim();
        return txt ? `<b style="font-size: 1em;">${txt}</b>\n\n` : "";
      }

      case "OL": {
        return (
          node.childNodes
            .filter((n) => n.tagName?.toUpperCase() === "LI")
            .map((li, i) => walk(li, depth, "ol", i + 1))
            .join("") + "\n\n"
        );
      }
      case "UL": {
        return (
          node.childNodes
            .filter((n) => n.tagName?.toUpperCase() === "LI")
            .map((li) => walk(li, depth, "ul"))
            .join("") + "\n\n"
        );
      }
      case "LI": {
        const prefix = listType === "ol" ? `${index}. ` : `${bulletEmoji} `;
        const txt = walkChildren(node).trim();
        return `${"  ".repeat(depth)}${prefix}${txt}\n`;
      }
      case "B":
      case "STRONG":
        return `<b>${walkChildren(node)}</b>`;
      case "I":
      case "EM":
        return `<i>${walkChildren(node)}</i>`;
      case "A": {
        const href = node.getAttribute("href") || "";
        const txt = walkChildren(node).trim();
        return `<a href="${href}">${txt}</a>`;
      }
      case "U":
        return `<u>${walkChildren(node)}</u>`;

      default:
        return walkChildren(node);
    }
  }

  function walkChildren(parent) {
    return parent.childNodes.map((child) => walk(child)).join("");
  }

  // 1) Build the intermediate plain‐text string:
  const plain = root.childNodes
    .map((node) => walk(node))
    .join("")
    .trim();

  // 2) Split into paragraphs, wrap in <p>…</p>
  const htmlText = plain
    .split("\n\n")
    .map((paragraph) => `<p>${paragraph.replace(/\n/g, "<br/>")}</p>`)
    .join("");

  return htmlText;
} */

function PreViewPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 15,
    totalItems: 0,
    totalPages: 0
  });
  const [tab, setTab] = useState("posted");
  const [filterType, setFilterType] = useState("all");
  const [selectedPosts, setSelectedPosts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [sendingToGroup, setSendingToGroup] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewPost, setPreviewPost] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [toast, setToast] = useState({ message: "", isError: false });

  // Define tabs
  const tabs = [
    { id: "posted", label: "Posted" },
    { id: "notPosted", label: "Not Posted" },
  ];

  const tabWidth = 150; // fixed width for tab buttons

  const handleCheckboxChange = (post) => {
    setSelectedPosts((prev) => {
      const isSelected = prev.some((p) => p.id === post.id);
      return isSelected
        ? prev.filter((p) => p.id !== post.id)
        : [...prev, post];
    });
  };

  const handleSendToGroup = async () => {
    try {
      setSendingToGroup(true);
      await sendToGroup(
        selectedPosts.map((post) => post.id),
        message,
        selectedCategories.length >= 0 ? selectedCategories.map(Number) : null
      );

      setShowModal(false);
      setSelectedPosts([]);
      setMessage("");
      setSelectedCategories([]); // Reset selected categories
      setToast({
        message: "Posts sent to group successfully!",
        isError: false,
      });

      // Refresh posts list
      fetchPosts(pagination.currentPage);
    } catch (error) {
      setToast({
        message: "Error sending posts to group: " + error.message,
        isError: true,
      });
    } finally {
      setSendingToGroup(false);
    }
  };

  useEffect(() => {
    const fetchCategoryList = async () => {
      try {
        const catList = await getCategories();
        if (catList) {
          setCategories(catList);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategoryList();
  }, []);

  const areAllSameType = () => {
    if (selectedPosts.length === 0) return false;
    const firstType = selectedPosts[0].type;
    return selectedPosts.every((post) => post.type === firstType);
  };

  const removeFromSelection = (postId) => {
    setSelectedPosts((prev) => prev.filter((p) => p.id !== postId));
  };

  const handleViewPost = async (postId) => {
    try {
      setLoadingPreview(true);
      setShowPreviewModal(true);
      const response = await fetchPostById(postId);
      setPreviewPost(response.post);
    } catch (error) {
      setToast({
        message: "Error loading post: " + error.message,
        isError: true,
      });
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleDelete = async (postId) => {
    if (window.confirm("Are you sure you want to delete this post?")) {
      try {
        await deletePost(postId);
        // Refresh the posts list
        fetchPosts(pagination.currentPage);
        setToast({ message: "Post deleted successfully!", isError: false });
      } catch (error) {
        setToast({
          message: "Error deleting post: " + error.message,
          isError: true,
        });
      }
    }
  };

  const fetchPosts = async (page = 1) => {
    setLoading(true);
    setError("");
    try {
      // map your UI state into the params:
      const isPosted = tab === "posted";
      const typeParam = filterType === "all" ? null : filterType;
      // pass them straight through with pagination:
      const response = await getAllPost(isPosted, typeParam, page);
      console.log(response);
      setPosts(response.posts || []);
      setPagination({
        currentPage: response.pagination.currentPage,
        pageSize: response.pagination.pageSize,
        totalItems: response.pagination.totalItems,
        totalPages: response.pagination.totalPages
      });
    } catch (err) {
      console.error("Error fetching posts:", err);
      setError("Error fetching posts");
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    fetchPosts(newPage);
  };

  useEffect(() => {
    // Reset to first page when tab or filter changes
    fetchPosts(1);
  }, [tab, filterType]);

  const parseOptions = {
    replace: (domNode) => {
      if (domNode.type === "tag") {
        const tagName = domNode.name;

        const tagStyles = {
          h1: "text-4xl font-extrabold my-4",
          h2: "text-3xl font-bold my-4",
          h3: "text-2xl font-semibold my-3",
          h4: "text-xl font-semibold my-3",
          h5: "text-lg font-medium my-2",
          h6: "text-base font-medium my-1",
          ul: "list-disc list-inside pl-4 my-2 space-y-1",
          ol: "list-decimal list-inside pl-4 my-2 space-y-1",
        };

        if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(tagName)) {
          return (
            <div className={tagStyles[tagName]}>
              {domToReact(domNode.children, parseOptions)}
            </div>
          );
        }

        if (["ul", "ol"].includes(tagName)) {
          return React.createElement(
            tagName,
            { className: tagStyles[tagName] },
            domNode.children.map((child, i) => (
              <li key={i}>{domToReact(child.children)}</li>
            ))
          );
        }
      }
    },
  };

  // Filter posts based on tab and type
  const filteredPosts = posts.filter((post) => {
    const postedMatch =
      tab === "posted" ? post.is_posted === true : post.is_posted === false;
    const typeMatch =
      filterType === "all" || post.type.toLowerCase() === filterType;
    return postedMatch && typeMatch;
  });

  const sortedPosts = [...filteredPosts].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  // Helper function to parse the post body content
  const parseBody = (body) => {
    if (typeof body === "object") return body;
    try {
      let parsed = JSON.parse(body);
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed); // handle double-encoded JSON
      }
      return parsed.map((block) => {
        if (block.type === "link" && typeof block.content === "object") {
          const urlObj = block.content.url || {};
          return {
            ...block,
            url:
              typeof block.content.url === "string"
                ? block.content.url
                : urlObj.url,
            displayText:
              block.content.displayText ||
              urlObj.displayText ||
              urlObj.url ||
              "",
          };
        }
        return block;
      });
    } catch (e) {
      console.error("Failed to parse body content:", e);
      return [{ type: "paragraph", text: body }];
    }
  };

  // extractImageFromHtml removed - not used

  const getFirstImageUrl = (blocks) => {
    if (Array.isArray(blocks)) {
      const imageBlock = blocks.find(
        (block) => block.type === "image" && block.url
      );
      return imageBlock ? imageBlock.url : null;
    }
    return null;
  };

  const getSnippetFromBlocks = (blocks, maxLength = 120) => {
    if (!Array.isArray(blocks)) return "";

    const stripHtml = (html) => html.replace(/<[^>]+>/g, ""); // removes all HTML tags

    const combinedText = blocks
      .filter((block) => block.type === "paragraph" && block.text)
      .map((block) =>
        typeof block.text === "string" ? stripHtml(block.text) : ""
      )
      .join(" ")
      .trim();

    return combinedText.length > maxLength
      ? combinedText.substring(0, maxLength) + "..."
      : combinedText;
  };

  const currentIndex = tabs.findIndex((t) => t.id === tab);

  useEffect(() => {
    if (!toast.message) return;
    const timer = setTimeout(
      () => setToast({ message: "", isError: false }),
      3000
    );
    return () => clearTimeout(timer);
  }, [toast]);

  return (
    <div className=" bg-gray">
      <DashboardStatusGrid />
      {/* Update container width here */}
      <div className="container mx-auto max-w-7xl py-10 bg-gray px-4">
        <div className="flex justify-between items-center">
          {selectedPosts.length > 0 && tab === "notPosted" && (
            <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Send to Group ({selectedPosts.length})
            </button>
          )}
        </div>
        {toast.message && (
          <div
            className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow z-50
      ${
        toast.isError
          ? "bg-red-100 border border-red-400 text-red-700"
          : "bg-green-100 border border-green-400 text-green-700"
      }`}
          >
            {toast.message}
            <button
              onClick={() => setToast({ message: "", isError: false })}
              className="ml-4 font-bold"
            >
              ×
            </button>
          </div>
        )}
        {/* Sliding Tabs */}
        <div className="mb-6 flex justify-center">
          <div className="relative inline-flex rounded-full bg-transparent p-1">
            <span
              className="absolute top-0 left-0 h-full rounded-full bg-green-500 transition-transform duration-300 ease-in-out"
              style={{
                width: `${tabWidth}px`,
                transform: `translateX(${currentIndex * tabWidth}px)`,
              }}
            ></span>
            {tabs.map((item) => (
              <button
                key={item.id}
                onClick={() => setTab(item.id)}
                style={{ width: `${tabWidth}px` }}
                className={`relative z-10 py-2 text-center font-bold ${
                  tab === item.id ? "text-white" : "text-gray-700"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        {/* Horizontal Filter Tabs */}
        <div className="mb-6 flex justify-center items-center space-x-4">
          <h2 className="text-xl font-rbold">Filter By Type :</h2>
          <button
            onClick={() => setFilterType("all")}
            className={`px-10 text-lg rounded transition-colors border-2 border-gray-700 ${
              filterType === "all"
                ? "bg-green-500 text-white"
                : "bg-transparent text-black"
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilterType("news")}
            className={`px-10 text-lg rounded transition-colors border-2 border-gray-700 ${
              filterType === "news"
                ? "bg-green-500 text-white"
                : "bg-transparent text-black"
            }`}
          >
            News
          </button>
          <button
            onClick={() => setFilterType("tender")}
            className={`px-10 text-lg rounded transition-colors border-2 border-gray-700 ${
              filterType === "tender"
                ? "bg-green-500 text-white"
                : "bg-transparent text-black"
            }`}
          >
            Tender
          </button>
          <button
            onClick={() => setFilterType("event")}
            className={`px-10 text-lg rounded transition-colors border-2 border-gray-700 ${
              filterType === "event"
                ? "bg-green-500 text-white"
                : "bg-transparent text-black"
            }`}
          >
            Event
          </button>
        </div>

        {loading ? (
          <div className="relative min-h-[calc(100vh-8rem)]">
            <Spinner size="xl" fullScreen={true} />
          </div>
        ) : error ? (
          <p className="text-red-500 text-center">{error}</p>
        ) : (
          // Horizontal card design: image on left, content on right
          <div className="grid grid-cols-1 gap-6">
            {sortedPosts.map((post) => {
              const structuredContent = parseBody(post.body);
              const imageUrl = getFirstImageUrl(structuredContent);
              const snippet = getSnippetFromBlocks(structuredContent);

              return (
                <div
                  key={post.id}
                  className="bg-transparent rounded-lg shadow-none border-b-2 py-3 overflow-hidden relative flex h-52"
                >
                  {tab === "notPosted" && (
                    <input
                      type="checkbox"
                      checked={selectedPosts.some((p) => p.id === post.id)}
                      onChange={() => handleCheckboxChange(post)}
                      className="absolute top-2 right-2 w-4 h-4 z-10"
                    />
                  )}
                  {/* Left Side: Image */}
                  <div className="w-1/3 h-full">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={post.title}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-400 flex items-center justify-center text-white">
                        No Image
                      </div>
                    )}
                  </div>
                  {/* Right Side: Content */}
                  <div className="w-2/3 p-4 flex flex-col justify-between h-full">
                    <div>
                      <h2 className="text-xl font-semibold mb-2 truncate">
                        {post.title}
                      </h2>
                      <p className="text-gray-500 text-sm mb-2">{snippet}</p>
                      <div className="mb-4">
                        <p className="text-gray-600 text-sm">
                          Source: {post.source}
                        </p>
                        <p className="text-gray-600 text-sm">
                          Type: {post.type}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center justify-end space-x-2">
                      <button
                        onClick={() => handleViewPost(post.id)}
                        className="px-10 py-2 bg-green-500 text-white rounded hover:bg-blue-600 text-sm"
                      >
                        View
                      </button>
                      <Link
                        to={`/ankuaru/editPost/${post.id}_${post.type}`}
                        className="px-10 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => handleDelete(post.id)}
                        className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Send to Group Modal */}
        {showModal && tab === "notPosted" && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
              <h2 className="text-2xl font-bold mb-4">Send Posts to Group</h2>

              {!areAllSameType() && (
                <div className="mb-4 p-4 bg-yellow-100 text-yellow-800 rounded">
                  Warning: Selected posts must be of the same type to send
                  together.
                </div>
              )}

              <div className="mb-4">
                <h3 className="font-semibold mb-2">Selected Posts:</h3>
                <div className="space-y-2">
                  {selectedPosts.map((post) => (
                    <div
                      key={post.id}
                      className="flex items-center justify-between bg-gray-50 p-2 rounded"
                    >
                      <div>
                        <span className="font-medium">{post.title}</span>
                        <span className="ml-2 text-sm text-gray-500">
                          ({post.type})
                        </span>
                      </div>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleViewPost(post.id)}
                          className="text-blue-500 hover:text-blue-700"
                        >
                          View
                        </button>
                        <button
                          onClick={() => removeFromSelection(post.id)}
                          className="text-red-500 hover:text-red-700"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* List of Checkboxes for Categories */}
              {selectedPosts.length === 1 &&
                selectedPosts.every(
                  (post) => post.type.toLowerCase() === "news"
                ) && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Select Categories
                    </label>
                    <div className="grid grid-cols-2 gap-2">
                      {categories.map((cat) => (
                        <label
                          key={cat.topic_id}
                          className="inline-flex items-center"
                        >
                          <input
                            type="checkbox"
                            value={cat.topic_id}
                            checked={selectedCategories.includes(
                              cat.topic_id.toString()
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const value = e.target.value;
                              if (checked) {
                                setSelectedCategories((prev) => [
                                  ...prev,
                                  value,
                                ]);
                              } else {
                                setSelectedCategories((prev) =>
                                  prev.filter((val) => val !== value)
                                );
                              }
                            }}
                            className="form-checkbox h-4 w-4 text-blue-600"
                          />
                          <span className="ml-2 text-gray-700">{cat.name}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message (Optional)
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full p-2 border rounded-md"
                  rows="4"
                  placeholder="Enter message..."
                ></textarea>
              </div>

              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border rounded hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendToGroup}
                  disabled={
                    !areAllSameType() ||
                    sendingToGroup ||
                    selectedPosts.length === 0
                  }
                  className={`px-4 py-2 rounded text-white ${
                    !areAllSameType() ||
                    sendingToGroup ||
                    selectedPosts.length === 0
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }`}
                >
                  {sendingToGroup ? "Sending..." : "Send to Group"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Post Preview Modal */}
        {showPreviewModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-y-auto">
              {loadingPreview ? (
                <div className="flex items-center justify-center h-40">
                  <Spinner size="lg" />
                </div>
              ) : previewPost ? (
                <>
                  <div className="flex justify-between items-start mb-6">
                    <h2 className="text-3xl font-bold">{previewPost.title}</h2>
                    <button
                      onClick={() => {
                        setShowPreviewModal(false);
                        setPreviewPost(null);
                      }}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>

                  <div className="mb-4 text-sm text-gray-500">
                    <p>Source: {previewPost.source}</p>
                    <p>
                      Posted on:{" "}
                      {new Date(previewPost.createdAt).toLocaleDateString()}
                    </p>
                  </div>

                  {(() => {
                    // Parse the body string into an array of blocks.
                    const blocks = parseBody(previewPost.body);
                    return (
                      <div className="prose max-w-none space-y-4">
                        {blocks.map((block, index) => {
                          switch (block.type) {
                            case "paragraph":
                              return (
                                <div
                                  key={index}
                                  className="text-justify text-black leading-relaxed"
                                >
                                  {typeof block.text === "string"
                                    ? parse(block.text, parseOptions)
                                    : null}
                                </div>
                              );

                            case "link":
                              const linkUrl =
                                typeof block.url === "string"
                                  ? block.url
                                  : block.url?.url || block.content?.url || "";

                              const linkText =
                                block.displayText ||
                                block?.url?.displayText ||
                                block?.url?.url ||
                                "Link";

                              return (
                                <div
                                  key={index}
                                  className="my-6 text-lg px-2 text-blue-600 underline hover:text-blue-800 dark:text-blue-400 cursor-pointer"
                                  onClick={() => {
                                    if (
                                      window?.Telegram?.WebApp?.openLink &&
                                      linkUrl
                                    ) {
                                      window.Telegram.WebApp.openLink(linkUrl);
                                    } else {
                                      window.open(linkUrl, "_blank");
                                    }
                                  }}
                                >
                                  {linkText}
                                </div>
                              );

                            case "image":
                              return (
                                <div key={index} className="mb-6">
                                  <img
                                    src={block.url}
                                    alt={block.alt || "Image"}
                                    className="w-full h-auto rounded-lg shadow-lg"
                                  />
                                </div>
                              );

                            case "quote":
                              return (
                                <blockquote
                                  key={index}
                                  className="border-l-4 pl-4 italic text-gray-700"
                                >
                                  {block.text}
                                  {block.author && (
                                    <cite className="block mt-1 text-right text-sm">
                                      — {block.author}
                                    </cite>
                                  )}
                                </blockquote>
                              );
                            case "subTopic":
                              return (
                                <h3
                                  key={index}
                                  className="text-xl font-bold mt-6"
                                >
                                  {block.text}
                                </h3>
                              );

                            case "table":
                              return (
                                <div key={index} className="my-6">
                                  <div className="border rounded-md overflow-auto max-h-64">
                                    <div
                                      className="min-w-full"
                                      dangerouslySetInnerHTML={{
                                        __html: block.html,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            case "document": {
                              const url = block.url;
                              const filename = block.name || url.split("/").pop();
                              const isPDF = /\.pdf$/i.test(url);

                              return (
                                <div
                                  key={index}
                                  className="my-6 border p-4 rounded bg-gray-50"
                                >
                                  <p className="font-medium mb-2">📎 {filename}</p>

                                  {isPDF && (
                                    <iframe
                                      src={url}
                                      title={filename}
                                      className="w-full h-64 border rounded mb-2"
                                    />
                                  )}

                                  <a
                                    href={url}
                                    download
                                    className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                                  >
                                    Download {filename}
                                  </a>
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}
                      </div>
                    );
                  })()}
                </>
              ) : (
                <div className="flex items-center justify-center h-40">
                  <p className="text-red-500">Error loading post</p>
                </div>
              )}
            </div>
          </div>
        )}
        
        {/* Pagination Controls */}
        {!loading && !error && pagination.totalPages > 1 && (
          <div className="flex justify-center mt-8 mb-4">
            <div className="flex items-center space-x-2">
              <button
                onClick={() => handlePageChange(1)}
                disabled={pagination.currentPage === 1}
                className={`px-3 py-1 rounded ${pagination.currentPage === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
              >
                &laquo;
              </button>
              
              <button
                onClick={() => handlePageChange(pagination.currentPage - 1)}
                disabled={pagination.currentPage === 1}
                className={`px-3 py-1 rounded ${pagination.currentPage === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
              >
                &lt;
              </button>
              
              {/* Page numbers */}
              <div className="flex space-x-1">
                {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                  // Show pages around current page
                  let pageNum;
                  if (pagination.totalPages <= 5) {
                    // If 5 or fewer pages, show all
                    pageNum = i + 1;
                  } else if (pagination.currentPage <= 3) {
                    // If near start, show first 5 pages
                    pageNum = i + 1;
                  } else if (pagination.currentPage >= pagination.totalPages - 2) {
                    // If near end, show last 5 pages
                    pageNum = pagination.totalPages - 4 + i;
                  } else {
                    // Otherwise show 2 before and 2 after current page
                    pageNum = pagination.currentPage - 2 + i;
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      onClick={() => handlePageChange(pageNum)}
                      className={`px-3 py-1 rounded ${pagination.currentPage === pageNum ? 'bg-green-500 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
              
              <button
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                disabled={pagination.currentPage === pagination.totalPages}
                className={`px-3 py-1 rounded ${pagination.currentPage === pagination.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
              >
                &gt;
              </button>
              
              <button
                onClick={() => handlePageChange(pagination.totalPages)}
                disabled={pagination.currentPage === pagination.totalPages}
                className={`px-3 py-1 rounded ${pagination.currentPage === pagination.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
              >
                &raquo;
              </button>
              
              <span className="ml-4 text-gray-600">
                Page {pagination.currentPage} of {pagination.totalPages} ({pagination.totalItems} items)
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PreViewPosts;
